import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { fiPaymentMethodTypeName } from '../payment-method-type';

@Pipe({
    name: 'fiPaymentMethodTypeName',
    standalone: false,
})
export class PaymentMethodTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiPaymentMethodTypeName(value, this.appText);
    }
}
